import { LoadingLayout } from 'components';
import { useTranslation } from 'libs/i18n';
import { ErrorFallback } from 'modules/App/ErrorFallback';

interface Props {
  isError: boolean;
}
export const LoginByTokenView = ({ isError }: Props) => {
  const { t } = useTranslation();

  if (isError) {
    return <ErrorFallback subtitle={t('auth.loginByToken.subtitle')} />;
  }
  return <LoadingLayout />;
};
